/**
 * Cache for in-flight promises to prevent duplicate async operations.
 */
class AsyncPromiseCache {
  private cache = new Map<string, Promise<unknown>>();

  getOrCreate<T>(key: string, factory: () => Promise<T>): Promise<T> {
    const existing = this.cache.get(key);
    if (existing) {
      return existing as Promise<T>;
    }

    const promise = factory().finally(() => this.cache.delete(key));
    this.cache.set(key, promise);

    return promise;
  }

  clearAll(): void {
    this.cache.clear();
  }
}

export const asyncPromiseCache = new AsyncPromiseCache();
